/*
const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};*/

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches label").forEach((input) => {
			input.addEventListener("click", (event) => {
				const color = input.getAttribute('val')
				console.log('color '+color)
				const product = input.getAttribute('product')
				const secondProduct = input.getAttribute('secondproduct')
				// console.log(input)
				console.log('.media-'+product+'.second-product-'+secondProduct)
				$('.media-' + product).attr('style','object-fit: contain;z-index: 0;')
				$('.media-'+product+'.second-product-'+secondProduct).css('display','block')
				$('.media-'+product+'.second-product-'+secondProduct).first().css('opacity','1')
				$('.media-' + product).not($('.media-' + product + '.second-product-'+secondProduct)).css('display','none')
				let url = $(input).attr('url')
				var productCard = $(input).closest('.collection-product-card');
				productCard.find('label').removeClass('round-border')
				$(input).addClass('round-border')
				console.log(url)
				productCard.find('a').each(function() {
					$(this).attr('href', url);
				});
				var variantsInfo = JSON.parse(document.getElementById('variants_data_'+product).textContent);
				let sizes = []
				let productPrice
				let productCompare
				let mainProduct
                let isAvailable
              let hasDiscount = false
				for(const variant of variantsInfo){
					if(variant.product == secondProduct){
						if(variant.available){
							sizes.push(variant.title)
						}
                        isAvailable = variant.available
						productPrice = variant.product_price
						productCompare = variant.product_compare_at_price
						mainProduct = variant.main
						let section_id = variant.section_id
						if(!variant.available){
							$('#'+section_id+'-so-'+variant.main).removeClass('d-none')
						}
						else{
							$('#'+section_id+'-so-'+variant.main).addClass('d-none')
						}
                      if(variant.has_discount){
                        hasDiscount = true
                      }
					}
				}
				console.log(sizes)
				$(input).closest('.collection-product-card').find('.size__modal').empty()
                if(isAvailable){
                  for(const size of sizes){
                      $(input).closest('.collection-product-card').find('.size__modal').append('<div class="size__btn" data-variantcolor="'+color+'" data-product="'+product+'" data-secondproduct="'+secondProduct+'" data-variantsize="'+size+'">'+size+'</div>')
                  }
                }
                else{
                  $(input).closest('.collection-product-card').find('.size__modal').append('<div class="out-of-stock">AGOTADO</div>')
                }
				console.log($('.product-card-'+ mainProduct +' .price'))
				if(productCompare){console.log('Hay compare')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productCompare)
					$('.product-card-'+ mainProduct +' .price-item.price-item--sale').text(productPrice)
					$('.product-card-'+ mainProduct +' .price__sale').css('display','flex')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','none')
					$('.product-card-'+ mainProduct +' .price').addClass('price--on-sale')
                   if(hasDiscount){
                     const badge = `<svg id="uuid-4f962d96-ae24-4f20-a414-dc5561913587" style="width:100%" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 310 156">
  <defs>
    <style>
      .cls-1 {
        fill: #1d1d1b;
      }

      .cls-1, .cls-2, .cls-3, .cls-4 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #e73056;
      }

      .cls-3 {
        fill: #010101;
      }

      .cls-4 {
        fill: #fff;
      }
    </style>
  </defs>
  <rect class="cls-1" x="4.8" y="78.1" width="205" height="73.7"/>
  <path class="cls-4" d="M30.2,125.7h-13.2v-8.1h13.2v8.1Z"/>
  <path class="cls-4" d="M53.6,136.2h-10.9v-30.9h-4.4v-9.5h15.3v40.5h0Z"/>
  <path class="cls-4" d="M62,133.8l1.3-9.6c3.2,1.9,6.1,2.8,8.7,2.8s3-.4,4-1.3c1-.8,1.6-1.9,1.6-3.3s-.6-2.5-1.7-3.3-2.7-1.2-4.8-1.2-4.6.5-7.1,1.4l3.1-23.6h20.1v9.5h-11.5l-.9,4.5h1.8c3.3,0,6.1,1.2,8.4,3.6s3.4,5.3,3.4,8.9-1.5,7.7-4.4,10.5c-2.9,2.8-6.6,4.2-11,4.2s-7.5-1-11.1-3.1h.1Z"/>
  <path class="cls-4" d="M110.6,105c0,2.9-.8,5.3-2.4,7.2s-3.7,2.8-6.2,2.8-4.9-.9-6.5-2.7c-1.6-1.8-2.4-4.3-2.4-7.4s.8-5.3,2.4-7c1.6-1.8,3.8-2.6,6.5-2.6s4.7.9,6.3,2.7,2.4,4.2,2.4,7.1h-.1ZM100.1,137.6l-4.2-3,28.6-40.5,4.3,3-28.8,40.5h0ZM103.5,105.2c0-2.7-.5-4.1-1.7-4.1s-1.7,1.3-1.7,4,.6,4,1.7,4,1.6-1.3,1.6-3.9h0ZM131.6,126.9c0,2.9-.8,5.3-2.4,7.2-1.6,1.8-3.7,2.8-6.2,2.8s-4.9-.9-6.6-2.7-2.4-4.3-2.4-7.4.8-5.3,2.4-7c1.6-1.8,3.8-2.6,6.5-2.6s4.7.9,6.3,2.7c1.6,1.8,2.4,4.2,2.4,7.1h0ZM124.5,127.1c0-2.7-.6-4.1-1.7-4.1s-1.7,1.3-1.7,4,.6,4,1.7,4,1.6-1.3,1.6-3.9h0Z"/>
  <path class="cls-4" d="M291.3,8.5h.7l.8,2.4h0l.8-2.4h.7v3h-.5v-2.3h0l-.8,2.3h-.4l-.8-2.3h0v2.3h-.5v-3h0Z"/>
  <path class="cls-4" d="M295.1,8.5h1.4c.3,0,.6,0,.8.2s.3.3.3.6v.4s0,.2-.1.2c0,0-.1,0-.2,0s0,0-.1,0h.1s.1,0,.1,0c0,0,0,0,.1.2v.8c0,0,0,.3.1.3h-.6v-1.1s-.1,0-.2,0h-1.1v1.2h-.5v-3h0ZM295.6,9.8h.9c.2,0,.3,0,.4,0,0,0,.1-.2.1-.4s0-.2,0-.2c0,0,0,0-.1,0h-1.3v.9h0Z"/>
  <path class="cls-4" d="M294.2,15.7c-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8,5.8,2.6,5.8,5.8-2.6,5.8-5.8,5.8ZM294.2,4.7c-2.9,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2,5.2-2.3,5.2-5.2-2.3-5.2-5.2-5.2Z"/>
  <path class="cls-3" d="M304.5,115.6s-4.1-28.8-5.1-35.7c-1.1-6.9,1.8-12.7,1.7-12.9l-3.3-2.8h0c.5-.4.9-.7,1.4-1.1,1.8-1.6,3.2-3.8,3.4-6.3.3-3-.1-6.1-.9-9-.4-1.6-1.4-4-2.2-5.3-1.7-3-3.6-5.7-4.8-9-.9-2.5-1.8-5.5-1.5-8.2.4-3.1-.4-3.7-.4-3.7h0l-13.7-13.8h-.2c0,0-3-1.1-2.1,17.2.1,2.1.1,4.4,0,6.6-.1,2-.9,3.6-2,5l-11.3-11.3c0-.2-.6-.3-2.1.3-2.4.9-4.7,2.6-6.5,4.5-1.8,2-2.7,4.5-3.5,7-.6,1.8-1.3,3.5-2.1,5.1h-.1c0,0-7-7.1-7-7.1h-.1c0-.1-.5-1.1-5,.3-4.5,1.4-54.8,8.9-54.8,8.9,0,0-6.1-.2-12.7,7.5-5.5,6.4-19.6,22.6-25.7,29.6-1.8,2.1-2.6,4.9-2,7.7l3.8,18.7c.4,1.8,1.3,3.5,2.7,4.8l13.8,13.8c.5.5,1,.9,1.6,1.2l33.7,20.9s3.9,3.1,13.3,3.1l77.6-11.9s9.9-1.3,14.7-11.6c1.8-3.9,2.3-8.3,1.7-12.5h-.3Z"/>
  <path class="cls-3" d="M210.5,151.9c-9.1,0-13.1-2.9-13.4-3.2l-33.7-20.9c-.6-.4-1.1-.8-1.6-1.3l-13.8-13.8c-1.4-1.3-2.4-3.1-2.8-5l-3.8-18.7c-.6-2.9.2-5.8,2.1-8,4.5-5.2,19.8-22.8,25.7-29.6,6.5-7.5,12.4-7.6,13-7.6,1.5-.2,50.3-7.5,54.7-8.9,4.1-1.3,5.1-.7,5.4-.3h.1c0,.1,6.8,6.9,6.8,6.9.8-1.6,1.4-3.2,1.9-4.6.9-2.8,1.8-5.2,3.6-7.1,1.9-2.1,4.3-3.7,6.6-4.6,1.5-.6,2-.5,2.3-.4.1,0,.2.1.3.3l11,11c1-1.5,1.6-2.9,1.7-4.5.1-1.9.1-4,0-6.5-.5-10.2.1-16.3,1.8-17.5.4-.3.7-.2.8-.2,0,0,.3,0,.4.2l13.6,13.7h0c.2.1.9.9.5,4-.3,2.6.6,5.5,1.5,8,.9,2.6,2.3,4.8,3.7,7.1.4.6.7,1.2,1.1,1.9.8,1.4,1.8,3.8,2.2,5.4.8,3.3,1.1,6.4.9,9.1-.2,2.4-1.5,4.7-3.5,6.5-.3.3-.7.5-1.1.8l2.9,2.5s0,0,.1.2c0,.2,0,.3-.2.8-.6,1.6-2.4,6.5-1.5,12.1,1.1,6.9,5.1,35.4,5.1,35.7.6,4.5,0,8.9-1.7,12.7-4.8,10.3-14.9,11.8-15,11.8l-77.6,11.9h-.1,0ZM210.5,151.6h0ZM182.2,44.6c-.3,0-6.1,0-12.4,7.4-5.9,6.8-21.1,24.4-25.7,29.6-1.8,2-2.5,4.7-1.9,7.4l3.8,18.7c.4,1.8,1.2,3.4,2.6,4.6l13.8,13.8c.5.5,1,.9,1.5,1.2l33.7,20.9h0c1.3,1.1,5.8,3,13,3h0l77.6-11.9c.1,0,9.8-1.4,14.4-11.4,1.7-3.7,2.3-8,1.7-12.3h0c0-.3-4.1-28.8-5.1-35.7-.9-5.8.9-10.8,1.5-12.5,0,0,0-.2.1-.3l-3.1-2.7c-.1,0-.2-.3-.1-.4h0q0-.2.2-.3c.5-.3,1-.6,1.3-1,1.9-1.7,3.1-3.9,3.3-6,.3-2.7,0-5.7-.9-8.9-.4-1.5-1.4-3.9-2.2-5.2-.4-.6-.7-1.2-1.1-1.8-1.4-2.3-2.8-4.6-3.7-7.3-.9-2.6-1.8-5.6-1.5-8.3.3-2.4-.1-3.1-.2-3.3h0l-13.7-13.8h0s-.1,0-.2,0c-.6.6-2,3.5-1.4,16.8.1,2.5.1,4.7,0,6.6s-.8,3.6-2.1,5.2c0,0-.2,0-.3,0s-.2,0-.3,0l-11.3-11.3h0s-.5,0-1.7.4c-2.2.8-4.5,2.4-6.3,4.4-1.7,1.8-2.6,4.2-3.5,6.9-.5,1.6-1.3,3.3-2.2,5.2,0,0-.1.2-.2.2h-.4c0,0-7-7.1-7-7.1h-.1c-.1-.1-1-.6-4.5.5-4.5,1.4-52.8,8.6-54.8,8.9h0l-.6-.3ZM300.7,67h0ZM263.2,25.5h0Z"/>
  <path class="cls-2" d="M285.5,66c-1.1-6.9,1.8-12.7,1.7-12.9,0-.2-7.2,9.3-13.2,9-1.9,0-4-.8-4.1-3-.2-3.7,4.4-5.4,7.3-6.3,2.9-.9,5.9-1.6,8.2-3.6s3.2-3.8,3.4-6.3c.3-3.1-.2-6.3-.9-9.2s-1.4-3.8-2.2-5.2c-1.7-3-3.6-5.7-4.8-9s-1.4-5.1-1.5-8.2-.1-2.5-.2-3-.7-.6-.9-.2c-.8,1.1-1.9,4.8-1.3,16.9.1,2.1.1,4.4,0,6.6-.2,3.4-2.3,5.6-4.7,7.8s-5.5,4.1-8.8,3.8c-5.6-.6-5.2-8-3.7-11.9.8-2.1,2.3-3.7,3.6-5.4,0,0,1.2-1.5-1.9-.3-2.4.9-4.7,2.6-6.5,4.5-1.8,2-2.7,4.5-3.5,7-1,3.1-2.5,6-4.1,8.8-.7,1.2-1.5,2.4-2.7,3.1-1.5,1-3.9,1-5.1-.5-1-1.2-1.1-3.2-1.2-4.8,0-1.9.4-3.9,1.2-5.7.3-.7.6-1.3,1.1-1.9s1.3-1.4,1.4-1.3c0,0-.4-.7-5,.4-6.9,1.7-54.8,8.9-54.8,8.9,0,0-6.1-.2-12.7,7.5-5.5,6.4-19.6,22.6-25.7,29.6-1.8,2.1-2.6,4.9-2,7.7l3.8,18.7c.5,2.4,2,4.6,4.1,5.9l33.7,20.9s3.9,3.1,13.3,3.1l77.6-11.9s9.9-1.3,14.7-11.6c1.8-3.9,2.3-8.3,1.7-12.5,0,0-4.1-28.8-5.1-35.7l-.2.2ZM169.5,102.6c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5,8.5,3.8,8.5,8.5-3.8,8.5-8.5,8.5Z"/>
  <path class="cls-3" d="M196.6,138.1c-9.1,0-13.1-2.9-13.4-3.2l-33.7-20.9c-2.2-1.4-3.7-3.6-4.3-6.1l-3.8-18.7c-.6-2.9.2-5.8,2.1-8,5.9-6.8,20.2-23.3,25.7-29.6,6.4-7.4,12.3-7.6,12.9-7.6s0,0,0,0c1.4-.2,48-7.2,54.7-8.9,2.8-.7,4.6-.9,5.2-.4h0v.2l-.3.2v.3h.1c-.2.1-1.1,1-1.2,1.2-.4.5-.7,1.1-1,1.8-.8,1.8-1.2,3.8-1.1,5.5,0,1.5.1,3.4,1.1,4.5,1.1,1.4,3.2,1.3,4.6.4,1-.6,1.8-1.6,2.6-3,1.9-3.4,3.2-6.1,4-8.7.9-2.8,1.8-5.2,3.6-7.1,1.9-2.1,4.3-3.7,6.6-4.6,1.5-.6,2.2-.6,2.5-.2s0,1-.2,1.1c-.3.3-.5.7-.8,1-1.1,1.4-2.2,2.7-2.8,4.3-1.1,2.8-1.5,6.9,0,9.3.7,1.2,1.9,1.9,3.4,2.1,2.7.3,5.5-.9,8.5-3.7,2.1-1.9,4.3-4.2,4.6-7.6.1-1.9.1-4,0-6.5-.6-11.8.4-15.8,1.4-17.1.2-.3.6-.4.9-.3.4,0,.6.4.7.7.1.7.2,1.7.2,3,0,2.9.5,5.5,1.5,8,.9,2.6,2.3,4.8,3.7,7.1.4.6.7,1.2,1.1,1.8.8,1.4,1.8,3.8,2.2,5.3.9,3.4,1.2,6.5.9,9.4-.2,2.4-1.5,4.7-3.5,6.5-2.1,1.8-4.7,2.6-7.2,3.3-.4,0-.8.2-1.2.3-4.9,1.5-7.1,3.4-7,5.9.1,2.3,2.9,2.6,3.8,2.6,4.8.2,10.4-6.1,12.3-8.2q.7-.8,1-.8h.2v.2c0,.2,0,.3-.2.8-.6,1.6-2.4,6.5-1.5,12.1h0c1.1,6.9,5.1,35.4,5.1,35.7.6,4.5,0,8.9-1.7,12.7-4.8,10.3-14.9,11.8-15,11.8l-77.6,11.9h0l.3.2ZM182.2,44.6c-.3,0-6.1,0-12.4,7.4-5.5,6.4-19.8,22.9-25.7,29.6-1.8,2-2.5,4.7-1.9,7.4l3.8,18.7c.5,2.3,1.9,4.4,3.9,5.6l33.7,20.9h0c1.3,1.1,5.8,3.1,13,3.1h0l77.6-11.9c.1,0,9.8-1.4,14.4-11.4,1.7-3.7,2.3-8,1.7-12.3,0-.3-4.1-28.8-5.1-35.7-.8-4.9.4-9.2,1.2-11.4-2.3,2.5-7.4,7.9-12.1,7.9h-.3c-2.1,0-4.4-1-4.5-3.3-.2-4.3,5.6-6.1,7.5-6.7.4,0,.8-.2,1.2-.3,2.4-.7,5-1.5,6.9-3.2s3.1-3.9,3.3-6c.3-2.7,0-5.8-.9-9.1-.4-1.5-1.3-3.7-2.1-5.1-.4-.6-.7-1.2-1.1-1.8-1.4-2.3-2.8-4.6-3.7-7.3-.9-2.6-1.4-5.3-1.5-8.3,0-1.6-.1-2.5-.2-2.9,0,0,0,0-.1,0h-.1c-.7,1-1.8,4.4-1.2,16.6.1,2.5.1,4.7,0,6.6-.3,3.6-2.6,6.1-4.8,8.1-3.2,2.9-6.2,4.2-9.1,3.9-1.7-.2-3.1-1-3.9-2.4-1.6-2.6-1.2-7,0-10,.7-1.8,1.8-3.1,2.9-4.5.3-.3.5-.6.8-1,0,0,0-.1.1-.2-.2,0-.6,0-1.6.4-2.2.8-4.5,2.4-6.3,4.4-1.7,1.8-2.6,4.2-3.5,6.9s-2.2,5.4-4.1,8.9c-.9,1.6-1.8,2.6-2.9,3.3-1.7,1-4.2,1.1-5.6-.6-1.1-1.3-1.2-3.5-1.2-5s.4-3.9,1.2-5.8c.3-.8.7-1.4,1.1-2,0,0,.4-.5.9-.9-.6,0-1.8,0-4.1.6-6.9,1.7-54.3,8.9-54.8,8.9h-.4ZM169.5,103c-4.9,0-8.8-4-8.8-8.8s4-8.8,8.8-8.8,8.8,4,8.8,8.8-4,8.8-8.8,8.8ZM169.5,86c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1,8.1-3.6,8.1-8.1-3.6-8.1-8.1-8.1Z"/>
  <path class="cls-4" d="M229.5,109.1c.3,0,.6,0,.8.2s.4.4.4.7,0,.6-.2.8c-.2.2-.4.4-.7.4s-.6,0-.8-.2-.4-.4-.4-.7,0-.6.2-.8c.2-.2.4-.4.7-.4Z"/>
  <path class="cls-4" d="M236.7,103l.3,2.1c-.4-.4-1-.6-1.7-.5-.5,0-.9.3-1.2.7-.3.4-.4.9-.3,1.4,0,.5.3,1,.7,1.2.4.3.9.4,1.4.3.6,0,1.1-.4,1.4-1l.3,2.1c-.7.3-1.2.5-1.5.6-1,.2-1.9,0-2.7-.6-.8-.5-1.3-1.4-1.5-2.4s0-1.9.6-2.6c.6-.8,1.4-1.3,2.4-1.5h1.7v.2Z"/>
  <path class="cls-4" d="M241.7,102.1c1-.2,1.9,0,2.8.6.9.6,1.4,1.3,1.5,2.3.2,1.1,0,2.1-.6,2.9s-1.4,1.3-2.5,1.5-2,0-2.9-.6c-.8-.6-1.3-1.4-1.5-2.5-.2-1,0-1.9.8-2.7.6-.8,1.5-1.2,2.5-1.4h-.1ZM242,103.8c-.5,0-.9.3-1.3.8-.3.4-.4.9-.4,1.3,0,.6.4,1,.8,1.4.4.3.9.5,1.5.4.5,0,1-.3,1.3-.8.3-.4.4-1,.3-1.5,0-.5-.3-.9-.8-1.2-.4-.3-.9-.4-1.4-.3h0Z"/>
  <path class="cls-4" d="M247.3,108.2v-7l1.8-.3,1.9,3.4.9-3.9,1.8-.3,2.1,6.6-1.8.3-1.1-3.8h0l-1,4.2h-.7c0,0-2.2-3.6-2.2-3.6h0v4l-1.8.3h.1Z"/>
  <path class="cls-4" d="M257.9,104.6c.3,0,.6,0,.8.2s.4.4.4.7,0,.6-.2.8c-.2.2-.4.4-.7.4s-.6,0-.8-.2-.4-.4-.4-.7,0-.6.2-.8c.2-.2.4-.4.7-.4Z"/>
  <path class="cls-4" d="M260.7,106.1v-7l1.8-.3,1.9,3.4.9-3.9,1.8-.3,2.1,6.6-1.8.3-1.1-3.8h0l-1,4.2h-.7c0,0-2.2-3.6-2.2-3.6h0v4l-1.8.3h.1Z"/>
  <path class="cls-4" d="M271.9,100.9l-2.7-2.8,2.2-.3,1.3,1.6.8-1.9,2.2-.3-1.7,3.5,3.1,3.2-2.1.3-1.8-2-1.2,2.5-2.1.3,2.1-4h0Z"/>
  <path class="cls-4" d="M214.7,78.8l-4.7.8,1,6.5-5.7.9-2.7-17,5.7-.9.9,5.8,4.7-.8-.9-5.8,5.7-.9,2.7,17-5.7.9-1-6.5Z"/>
  <path class="cls-4" d="M222.5,75.2c-.2-1.4-.2-2.6.1-3.8.3-1.2.8-2.2,1.5-3.1s1.6-1.7,2.7-2.3c1.1-.6,2.3-1,3.6-1.2s2.6-.2,3.9,0c1.2.2,2.3.7,3.3,1.3s1.8,1.5,2.4,2.5c.7,1,1.1,2.2,1.3,3.6s.2,2.6-.1,3.8c-.3,1.2-.8,2.3-1.5,3.2-.7.9-1.6,1.7-2.7,2.3-1.1.6-2.3,1-3.6,1.3-1.3.2-2.6.2-3.9,0-1.2-.2-2.3-.7-3.3-1.4-1-.7-1.8-1.5-2.4-2.6-.7-1-1.1-2.2-1.3-3.6ZM228.6,74.4c0,.6.3,1.1.5,1.5s.5.8.9,1.1c.4.3.7.5,1.2.6.4,0,.9,0,1.4,0,.5,0,.9-.2,1.3-.5.4-.2.7-.6.9-1s.4-.8.5-1.3v-1.6c0-.5-.3-1-.5-1.5-.2-.4-.5-.8-.9-1-.4-.3-.8-.5-1.2-.6s-.9,0-1.4,0c-.5,0-.9.2-1.3.5-.4.2-.7.5-1,.9-.2.4-.4.8-.5,1.3v1.5h.1Z"/>
  <path class="cls-4" d="M253,79.2l-5.7.9-2-12.2-4.2.7-.8-4.8,14.1-2.3.8,4.8-4.2.7,2,12.2h0Z"/>
  <path class="cls-4" d="M194.3,98.2l3.9-.6.6,3.5-3.9.6.7,4.3-4.2.7-2.1-12.8,8.7-1.4.6,3.6-4.4.7.2,1.3h-.1Z"/>
  <path class="cls-4" d="M202.4,91.8l4.6-.7,7.1,12-4.7.8-1-1.8-4.1.7-.3,2-4.6.7,3-13.6h0ZM205.3,96l-.5,3.3,2.1-.3-1.5-3h-.1Z"/>
  <path class="cls-4" d="M219.2,102.7c-.5,0-1,0-1.6,0s-1,0-1.5-.2c-.5,0-1-.2-1.4-.4-.4-.2-.9-.4-1.2-.6l2.2-3.3c.4.3.8.5,1.3.7s1.1.2,1.6,0c.2,0,.5,0,.6-.2.2,0,.3-.3.2-.5,0,0,0-.2-.1-.3l-.4-.2c-.2,0-.4,0-.7-.2-.3,0-.7,0-1.2-.2-.5,0-.9-.2-1.3-.3s-.8-.3-1.2-.6c-.4-.2-.7-.5-.9-.9s-.4-.8-.5-1.4c-.1-.8,0-1.5.2-2.1s.6-1.1,1-1.6c.5-.4,1-.8,1.6-1,.6-.3,1.2-.4,1.9-.5.8,0,1.7,0,2.7,0,.9.2,1.8.5,2.5,1l-2.2,3.2c-.3-.3-.7-.5-1.2-.7-.5,0-.8-.2-1.2,0-.3,0-.6,0-.7.3-.2,0-.3.3-.2.5,0,.2.2.3.4.4.2,0,.6,0,1,.2.5,0,1,.2,1.5.3.5,0,1,.3,1.5.5s.9.6,1.2,1,.6.9.7,1.6c.1.8,0,1.5-.1,2.1-.2.6-.5,1.2-1,1.6s-1,.8-1.6,1.1c-.6.3-1.2.5-1.9.6h0Z"/>
  <path class="cls-4" d="M233.1,95l-3.5.6.8,4.9-4.3.7-2.1-12.8,4.3-.7.7,4.3,3.5-.6-.7-4.3,4.3-.7,2.1,12.8-4.3.7-.8-4.9Z"/>
  <path class="cls-4" d="M238.6,86l4.3-.7,2.1,12.8-4.3.7-2.1-12.8Z"/>
  <path class="cls-4" d="M245.7,91.4c-.2-1-.1-2,0-2.9.2-.9.6-1.7,1.2-2.4.5-.7,1.2-1.2,2-1.7s1.7-.8,2.7-.9,2-.2,2.9,0,1.7.5,2.5,1c.7.5,1.3,1.1,1.8,1.9s.8,1.7,1,2.7.1,2,0,2.9c-.2.9-.6,1.7-1.2,2.4-.5.7-1.2,1.3-2,1.8s-1.7.8-2.7.9-2,.2-2.9,0-1.7-.5-2.5-1c-.7-.5-1.3-1.1-1.8-1.9s-.8-1.7-1-2.7h0ZM250.3,90.6c0,.4.2.8.4,1.1s.4.6.7.8c.3.2.6.4.9.5.3,0,.7,0,1,0,.4,0,.7-.2,1-.4.3-.2.5-.4.7-.7.2-.3.3-.6.4-1v-1.2c0-.4-.2-.8-.4-1.1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.3-.9-.4h-1c-.4,0-.7.2-1,.4-.3.2-.5.4-.7.7-.2.3-.3.6-.4,1v1.2h0Z"/>
  <path class="cls-4" d="M260.8,82.4l4.3-.7,4.7,5.9h0l-1.2-6.5,4.1-.7,2.1,12.8-4.4.7-4.5-5.6h0l1.2,6.1-4.1.7-2.1-12.8h-.1Z"/>
</svg>`
                     $('.product-card-'+ mainProduct +' .discount-season-badge').html(badge)
                   }
                   else{
                     $('.product-card-'+ mainProduct +' .badge--bottom-left.cap').css('display','flex')
					 $('.product-card-'+ mainProduct +' .badge--bottom-left').text('-'+Math.ceil(100 - (parseFloat(productPrice.replace('$ ', '').replace(',', '')) * 100 / parseFloat(productCompare.replace('$ ', '').replace(',', ''))))+'%')
                   }
                 }
				else{
                   $('.product-card-'+ mainProduct +' .badge--bottom-left.cap').css('display','none')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productPrice)
					$('.product-card-'+ mainProduct +' .price').removeClass('price--on-sale')
					$('.product-card-'+ mainProduct +' .price__sale').css('display','none')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','flex')
				}
				quickPurchase()
				/*
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
				*/
			});
		});
	});
	hideColorOptions()
};

const quickPurchase = () => {
	// $('.quick_add_btn').off('click').on('click', function() {
	// 	$(this).closest('.collection-product-card').find('.size__modal').toggleClass('op-1');
	//   });
	$('.size__btn').off('click').on('click', async function() {
      console.log('Entra al quick')
	  const color = $(this).attr('data-variantcolor');
	  const size = $(this).attr('data-variantsize');
	  const product = $(this).attr('data-product');
	  const secondProduct = $(this).attr('data-secondproduct');
	  var variantsInfo = JSON.parse(document.getElementById('variants_data_' + product).textContent);
		// console.log('Entra al quick')
	  for (const variant of variantsInfo) {
			if(variant.product == secondProduct){
				// console.log(variant)
				if (variant.title == size) {
					// console.log(variant.id);
                    let currentCart = await PCgetCurrentCart()
                    let hasGift = await PCcheckForGift(currentCart)
                    if(hasGift){
                        PChandleErrorMessage(product,"No puedes agregar un producto si tienes una Gift Card en tu carrito");
                        return
                    }
    				PChandleErrorMessage(product)

					let config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];
					const cart = document.querySelector("cart-drawer")
					const formData = new FormData();
					formData.append('TALLA', size);
					formData.append('form_type', 'product'); 
					formData.append('id', variant.id);
					formData.append('quantity', '1');
					formData.append('properties[color]', color);
					formData.append('product-id', product);
					if (cart) {
						formData.append(
							"sections",
							cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						cart.setActiveElement(document.activeElement);
					}
					config.body = formData;
					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
  console.log('Antes de hacer upload')
							ncaddToken()
                    executeWhenUpdated()
							uploadCart() 
							if (response.status) {
								publish(PUB_SUB_EVENTS.cartError, {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.description,
									message: response.message,
								});
								PChandleErrorMessage(response.description);

								const soldOutMessage =
									this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButton.querySelector("span").classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!cart) {
								window.location = window.routes.cart_url;
								return;
							}

							if (!this.error)
								publish(PUB_SUB_EVENTS.cartUpdate, {
									source: "product-form",
									productVariantId: formData.get("id"),
								});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											cart.renderContents(response);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								cart.renderContents(response);
							}
						})
						.catch((e) => {
							console.error(e);
						})
				}
			}
	  }
	});
};

$(document).ready(function(){
	hideColorOptions()
})

function hideColorOptions(){
	$('.product-form__controls').on("mouseover",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','block')
			})
			$(this).find(".more-elements").css('display','none')
		}
	})
	$('.product-form__controls').on("mouseout",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','none')
			})
			$(this).find(".more-elements").css('display','block')
		}
	})
}


function colorSwatches() {
	checkSwatches();
	quickPurchase();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		quickPurchase();
	});
}

(function () {
	colorSwatches();
	quickPurchase();
})();

function toggleCheck(id){
	const element = document.getElementById(id);
	element.checked = !element.checked;
}



async function PCcheckForGift(cart){
  console.log('Revisa si hay Gift')
  let sku_list = ['9909909_000250','9909909_000500','9909909_000600','9909909_000700','9909909_000800','9909909_000900','9909909_001000','9909909_002000']
  for(let item of cart.items){
    if(sku_list.includes(item.sku)){
      return true
    }
  }
  return false
}

async function PCgetCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return cart
  }

function PChandleErrorMessage(productid, errorMessage = false) {
	console.log(productid)
	let errorMessageWrapper = document.querySelector(".product-form__error-message-wrapper.pid-"+productid);
	if (!errorMessageWrapper) return;
	errorMessageContainer = errorMessageWrapper.querySelector(
			".product-form__error-message"
		);

	errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

	if (errorMessage) {
		errorMessageContainer.textContent = errorMessage;
	}
}